import React, { useEffect, useState } from 'react'

import { parseNumber } from '../../helpers/common'
import InputRangeSingle from '../UI/InputRangeSingle/InputRangeSingle'
import styles from './InvestmentFilter.module.scss'
import { StartSliderValue } from './InvestmentFilter.types'

function InvestmentFilterSliders(props: {
  filterHandler(value: string, name: string, checked?: boolean): void
  startValue: StartSliderValue
  nameEventReset: string
  resetCount: number
}) {
  const { filterHandler, startValue, nameEventReset, resetCount } = props

  const [accValue, setAccValue] = useState<{
    cash: string
    credit: string
  }>({
    cash: '0',
    credit: '0',
  })

  const onChange = (value: string, name: string) => {
    setAccValue(prev => ({
      ...prev,
      [name]: value,
      ...(accValue.credit === '0' && name !== 'credit'
        ? { credit: startValue.credit.toString() }
        : {}),
      ...(accValue.cash === '0' && name !== 'cash'
        ? { cash: startValue.cash.toString() }
        : {}),
    }))
  }

  const renderSlider = (name: string, label: string, min: number) => (
    // <div className={[styles['filter-item'], styles['width-182']].join(' ')}>
    <div className={styles['filter-item']}>
      <span className={styles['filter-item__name']}>{label}</span>
      <InputRangeSingle
        label={'₽'}
        min={min}
        max={36000000}
        step={500000}
        name={name}
        disableInput={true}
        onChange={input => {
          onChange(input.value, input.name)
          // filterHandler(input.value, input.name)
        }}
        startValue={startValue[name as keyof StartSliderValue]}
        nameEventReset={nameEventReset}
      />
    </div>
  )

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
    const summ = parseNumber(accValue.cash) + parseNumber(accValue.credit)
    filterHandler(`${summ}`, 'price-to')
  }, [accValue])

  useEffect(() => {
    setAccValue({
      cash: '0',
      credit: '0',
    })
  }, [resetCount])

  return (
    <>
      {renderSlider('cash', 'У меня есть', 1000000)}
      {renderSlider('credit', 'Готов взять в ипотеку', 0)}
    </>
  )
}

export default InvestmentFilterSliders
